import React from "react";

const TechStackCard = () => {
  const techStack = [
    { id: 1, name: "HTML" },
    { id: 2, name: "CSS" },
    { id: 3, name: "JavaScript" },
    { id: 4, name: "TypeScript" },
    { id: 5, name: "React.js" },
    { id: 6, name: "Next.js" },
    { id: 7, name: "Tailwind CSS" },
    { id: 8, name: "Material UI" },
    { id: 9, name: "GitHub" },
    { id: 10, name: "React Native" },
    { id: 11, name: "Redux Toolkit" },
  ];

  return (
    <div className="card shadow-lg compact bg-base-100">
      <div className="card-body">
        <div className="mx-3">
          <h5 className="card-title">
            <span className="text-base-content opacity-70">Tech Stack</span>
          </h5>
        </div>
        <div className="p-3 flow-root">
          <div className="-m-1 flex flex-wrap justify-center">
            {techStack.map((item) => (
              <div
                key={item.id}
                className="m-1 text-sm inline-flex items-center font-bold leading-sm px-3 py-1 bg-[#2b7489] text-white bg-opacity-90 rounded-full"
              >
                {item.name}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TechStackCard;
